module.exports = __webpack_public_path__ + "static/media/logo-dipp-text.9abae0f8.svg";